import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import merge from 'lodash/merge';
import chunk from 'lodash/chunk';
import qs from 'qs';
import List from '../List';
import Form from '../Form.js';
import { stringifyFacets } from '../../../utils/products.js';
import commify from '../../../modules/ajio-util/commify.js';
import { hideModal } from '../../../actions/modal.js';
import Modal from '../Modal';
import Button from '../Button.js';
import { setCurentFacetsQuery } from '../../../actions/shared/facets';
import { generateEvent } from '../../../utils/dataGrinch';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { getEnableFilterImprovement,getFilterImprovementConfig } from '../../../refresh/selectors/featureFlagsSelector';

class FacetCheckboxModalContentDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: {
        brand: {
          showPopular: true,
          groupByAlphabets: true
        }
      }
    };
  }

  getFormDefaultValues() {
    const { facetsQuery } = this.props;
    return merge({}, facetsQuery);
  }

  setSeletedL1Category(entityId) {
    this.setState({ seletedL1Category: entityId });
  }

  setSeletedL3Alphabet(alp) {
    const { selectedL2Alphabet } = this.state;
    if (selectedL2Alphabet !== alp) {
      return this.setState({ selectedL2Alphabet: alp });
    }
    this.setState({ selectedL2Alphabet: undefined });
  }

  /**
   *  method the name L3 name from the entity
   *  name = Boys (L1 category) - Boxers, Briefs & Trunks (L3 category);
   */

  getL3CategoryFromName(name = '', lowerCase = false) {
    let l3Category;
    l3Category = name.substring(name.indexOf('-') + 1).trim();
    l3Category = lowerCase ? l3Category.toLowerCase() : l3Category;
    return l3Category;
  }

  /**
   * Method which displays the content of the render method.
   * entities may sometimes looks like (facettype - gender (l1) - productname (l3))
   * entities is group of data (facettype * ('code' inside values for each item of values inside facettype)) + facets
   */
  renderCategoryModal() {
    const {
      entities = {},
      pushToHistory,
      facetsQuery = {},
      facetId,
      newDesignLuxe,
      getFilterImprovementConfig,
      enableImprovedFacets = false,
      plpGender = ''
    } = this.props;

    let { selectedAlphabet, seletedL1Category, selectedL2Alphabet } = this.state;
    const facetConfig = this.state.config ? this.state.config[facetId] || {} : {};

    const facet = entities[facetId] || {};
    const { name = '', childrens = [], code, suggestedValues = [] } = facet;

    /**
     *  children is nothing but 1 value from entity
     */
    const valuesForFacet = childrens;

    /**
     * Method to group & get total item count of L1 category
     * to show in popup leftpane & return value of method looks like :
     *    l1Categories = {
     *      entities : {
     *        boys : {count : 2000},
     *        men : {count: 10000},
     *      },
     *      results : ["boys", "men"]
     *    }
     * NOTE: 'results' is holding all the keys for 'entities' object
     */

    const l1Categories = valuesForFacet.reduce(
      (acc, entityId) => {
        const entity = entities[entityId];
        const { name = '', count } = entity;
        const nameSplits = name.split('-');
        let l1Category;

        if (nameSplits[0]) {
          l1Category = nameSplits[0].trim().toLowerCase();
        }

        if (l1Category && !acc.results.includes(l1Category)) {
          acc.results.push(l1Category);
          acc.entities[l1Category] = { count };
        } else if (l1Category && acc.results.includes(l1Category)) {
          acc.entities[l1Category].count = acc.entities[l1Category].count + count;
        }
        return acc;
      },
      { results: [], entities: {} }
    );

    /**
     * Method to sort the the previous generated 'results' array
     * based on total item count. Now 'results' will look like ["men", "boys"]
     */

    if (l1Categories.results && l1Categories.results.length > 0) {
      l1Categories.results.sort((entityIdA, entityIdB) => {
        const entityA = l1Categories.entities[entityIdA];
        const entityB = l1Categories.entities[entityIdB];
        if (entityA.count > entityB.count) {
          return -1;
        } else if (entityA.count < entityB.count) {
          return 1;
        }
        return 0;
      });
    }

    /**
     * To highlight the selected L1Categories. Right pane options is displayed whichever is preselected.
     * if none is selcted. Default 1st element should be selected.
     */

    if (!seletedL1Category && l1Categories.results) {
      seletedL1Category =
        enableImprovedFacets && plpGender && plpGender.toLowerCase() !== 'general'
          ? plpGender.toLowerCase()
          : l1Categories.results[0];
    }

    /**
     *  Group the data from 'entities' field for selected L1 category on the left-pane
     *  and return data looks like
     *  [
     *    "l1l3nestedcategory-Men - Backpacks & Laptop Bags",
     *    "l1l3nestedcategory-Men - Belts"
     *  ]
     */
    const allCategoryItems = valuesForFacet.filter(entityId => {
      const entity = entities[entityId];
      const { name } = entity;
      const l3Category = this.getL3CategoryFromName(name, true);

      if (name && seletedL1Category && name.toLowerCase().startsWith(seletedL1Category)) {
        return true;
      }
      return false;
    });

    const suggestedEntityIds = enableImprovedFacets
      ? suggestedValues.filter(entityId => {
          const entity = entities[entityId];
          const { name } = entity;

          if (name && seletedL1Category && name.toLowerCase().startsWith(seletedL1Category)) {
            return true;
          }
          return false;
        })
      : [];

    const visibleItemsForSelectedL1Categories = allCategoryItems.filter(entityId => {
      const entity = entities[entityId] || {};
      const { name } = entity;
      const l3Category = this.getL3CategoryFromName(name, true);

      /**
       *  Filter to product after any alphabet is selected from top
       */
      if (selectedL2Alphabet && l3Category) {
        if (l3Category.startsWith(selectedL2Alphabet)) {
          return true;
        } else {
          return false;
        }
      }
      /*
       This logic is overriden by top line. (Old logic)
      if (selectedL2Alphabet && l3Category && !l3Category.startsWith(selectedL2Alphabet)) {
        return false;
      }

      if (name && seletedL1Category && name.toLowerCase().startsWith(seletedL1Category)) {
        return true;
      }
      */
      return false;
    });

    const visibleItemAry =
      visibleItemsForSelectedL1Categories.length > 0
        ? visibleItemsForSelectedL1Categories
        : allCategoryItems;

    /**
     * Pushing first character of visible item
     */
    let availableAlphabets = visibleItemAry.reduce((acc, entityId) => {
      const entity = entities[entityId] || {};
      const { name } = entity;
      const l3Category = this.getL3CategoryFromName(name, true);
      if (l3Category && !acc.includes(l3Category.charAt(0))) {
        acc.push(l3Category.charAt(0));
      }
      return acc;
    }, []);

    let filterChunks = [];
    const chunkSize = newDesignLuxe ? 9 : 12;
    if (suggestedEntityIds && suggestedEntityIds.length > 0) {
      const suggestedTitle = this.props.filterImprovementConfig?.category?.suggestedTitle?.toUpperCase() || 'SUGGESTED';
      filterChunks.push([{ title: suggestedTitle }, ...suggestedEntityIds]);
      
      // Add regular items in subsequent chunks
      const regularChunks = chunk(visibleItemAry, chunkSize);
      filterChunks = [...filterChunks, ...regularChunks];
    }else {
      // No suggested values, just chunk regular items
      filterChunks = chunk(visibleItemAry, chunkSize);
    }

    /**
     *  Partition items into columns based on count (Here it is 12).
     */
    // const filterChunks = chunk(formattedItems, newDesignLuxe ? 9 : 12);
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;

    const modalName = 'facet-filter-modal-category';

    let hasL1Category = true;
    if (enableImprovedFacets) {
      const selectedFromUrl = facetsQuery?.genderfilter;
      // hasL1Category = !(selectedFromUrl && selectedFromUrl.length === 1) && !(plpGender && plpGender.toLowerCase() != "General"); //commented coz user can select multiple gender if plpGender is General
      hasL1Category = !(plpGender && plpGender.toLowerCase() != "general");
    }

    const selectedGenders = facetsQuery?.genderfilter && !!facetsQuery?.genderfilter?.length;
    const genderFilters = (facetsQuery?.genderfilter || [])?.map(el => el.toLowerCase());
    const filteredL1Categories =
      enableImprovedFacets && selectedGenders
        ? {
            ...l1Categories,
            results: l1Categories.results.filter(el => genderFilters.includes(el))
          }
        : l1Categories;
   
    return (
      <Modal
        name={modalName}
        className={`facet-filter-modal ${filterChunks.length > 2 ? 'width-1024' : 'width-1024'}`}
        onClose={() => {
          /**
           * Resetting back to undefined (Selected alphabet from top)
           * & L1 category name.
           */
          this.setSeletedL3Alphabet();
          this.setSeletedL1Category();
        }}
        noBackdrop={false}
      >
        <Form
          defaultValues={this.getFormDefaultValues()}
          onSubmit={formValues => {
            if (newDesignLuxe) {
              gtmEventPush({
                event: 'plp_filter_apply',
                event_category: 'product list interactions',
                event_action: 'filter applied',
                event_label: Object.values(formValues).toString(),
                no_of_filters: Object.keys(formValues).length,
                store_type: name,
                screen_name: screenName,
                screen_type: screenType
              });
              
              segmentEventPush({
                event: 'Plp Filter Applied',
                event_category: 'product list interactions',
                event_action: 'filter applied',
                event_label: Object.values(formValues).toString(),
                no_of_filters: Object.keys(formValues).length,
                l1_filter: Object.values(formValues).toString(),
                store_type: name,
                screen_name: screenName,
                screen_type: screenType
              })

            } else {
              generateEvent({
                Event: 'Filter',
                value: {
                  'ListOfFilters:': qs.stringify(formValues)
                }
              });

              segmentEventPush({
                event: 'Plp Filter Applied',
                event_category: 'product list interactions',
                event_action: 'filter applied',
                event_label: Object.values(formValues).toString(),
                no_of_filters: Object.keys(formValues).length,
                l1_filter: Object.values(formValues).toString(),
                store_type: name,
                screen_name: screenName,
                screen_type: screenType
              })
              
            }
            this.props.setCurentFacetsQuery(formValues);
            pushToHistory({
              facets: stringifyFacets(formValues),
              currentPage: 0
            });
            this.props.hideModal(modalName);
            this.setSeletedL3Alphabet();
            this.setSeletedL1Category();
          }}
        >
          {({ getFormDefaultProps, getFormValue, isTouched, addFormValue }) => {
            return (
              <div
                className={`${
                  newDesignLuxe ? 'luxe-newdesign' : ''
                } more-popup-container facet-category-filter`}
              >
                <div className="facet-filter-modal__header">
                  <div className="facet-filter-modal__title" aria-label={`Choose ${facet.name}`}>
                    Choose <span>{facet.name}</span>
                  </div>
                </div>
                <div className="facet-filter-modal__body">
                 { hasL1Category &&  
                    <div className="facet-filter-modal__body-left" >
                      <List
                        numOfItems={filteredL1Categories.results.length}
                        treatAsTabs={true}
                        listItemRenderer={listProps => {
                          const { index } = listProps;
                          const entityId = filteredL1Categories.results[index];
                          const entity = filteredL1Categories.entities[entityId] || {};
                          const { count = 0 } = entity;
                          return (
                            <div
                              onClick={() => {
                                this.setSeletedL3Alphabet();
                                this.setSeletedL1Category(entityId);
                              }}
                            >
                              <div
                                className={`facet-linkname facet-category-title ${entityId == seletedL1Category ? 'list-active' : ''
                                  }`}
                              >
                                <span className="rilrtl-list-item__title">
                                  {`${entityId}`}{' '}
                                  <span className="facet-cat-count" aria-label={`with ${count} items`}> {`(${count})`}</span>
                                </span>
                              </div>
                            </div>
                          // </div>
                        );
                      }}
                      getAriaSelected={(index) => {
                        const entityId = l1Categories.results[index];
                        return entityId === seletedL1Category;
                      }}
                      keepDefaultRole={true}
                    />
                  </div>}
                  <div className={`facet-filter-modal__body-right ${
                    enableImprovedFacets && !hasL1Category ? 'facet-filter-modal__body-right-l1selected' : ''
                     }`} id="right-pane-body">
                    <div className="facet-filter-modal__body-right-top" />
                    <ul className="facet-filter-modal__search-alp-container" role="tablist">
                      {[
                        'a',
                        'b',
                        'c',
                        'd',
                        'e',
                        'f',
                        'g',
                        'h',
                        'i',
                        'j',
                        'k',
                        'l',
                        'm',
                        'n',
                        'o',
                        'p',
                        'q',
                        'r',
                        's',
                        't',
                        'u',
                        'v',
                        'w',
                        'x',
                        'y',
                        'z'
                      ].map((item, key) => {
                        let selectedAlp = this.state.selectedL2Alphabet;
                        const firstAvailable = availableAlphabets[0]; 
                        return (
                          <li
                            id={`alphabet-tab-${item}`}
                            role="tab"
                            type="button"
                            aria-controls="alphabets-tabpanel"
                            aria-selected={selectedAlp === item}   // stays false if nothing is selected
                            aria-disabled={!availableAlphabets.includes(item)}
                            disabled={!availableAlphabets.includes(item)}
                            className="rilrtl-button"
                            key={key}
                            onClick={() => {
                              this.setSeletedL3Alphabet(item);
                            }}
                            onKeyDown={(e) => {
                              // if (!availableAlphabet) return;

                              if (e.key === "Enter" || e.key === " ") {
                                if(Array.isArray(availableAlphabets) && availableAlphabets.includes(item)){
                                  e.preventDefault();
                                  e.currentTarget.click();
                                }
                              } else if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                                e.preventDefault();
                                const tabs = document.querySelectorAll('[role="tab"]');
                                const currentIndex = Array.from(tabs).indexOf(e.currentTarget);
                                const nextIndex =
                                  e.key === "ArrowRight"
                                    ? (currentIndex + 1) % tabs.length
                                    : (currentIndex - 1 + tabs.length) % tabs.length;

                                (tabs[nextIndex]).focus();
                              }
                            }}
                            tabIndex={
                              !availableAlphabets.includes(item)
                                ? -1
                                : selectedAlp === item
                                  ? 0
                                  : selectedAlp
                                    ? -1
                                    : item === firstAvailable
                                      ? 0   // first available if none selected
                                      : -1
                            }
                          >
                            <div
                              className={`item-selected ${selectedAlp == item ? 'active-alp' : ''}`}
                              aria-label={`brands staring with ${item}`}
                            >
                              {item}
                            </div>
                            <div
                              className={`ic-close ${selectedAlp == item ? 'active-alp' : ''}`}
                            />
                          </li>
                        );
                      })}
                    </ul>
                    <div className="selection-wrapper">
                      {filterChunks.map((filterChunk, k_filterChunk) => {
                        return (
                          <div
                            className={`column column-${filterChunks.length}`}
                            key={`column-${k_filterChunk}`}
                          >
                            {filterChunk.map((itemId, k_item) => {
                               if (typeof itemId === 'object' && itemId.title) {
                                return (
                                  <div key={`title-${k_item}`} role="heading" aria-level={3}>
                                    <div className="facet-suggested-heading">
                                      {itemId.title}
                                    </div>
                                  </div>
                                );
                              }
                              const item = entities[itemId] || {};
                              let { name, count, code, selected, isAlphabet } = item;
                              const nameSplits = name.split('-');
                              let l3Category = this.getL3CategoryFromName(name, true);
                              let isChecked = false;
                              let formValue = getFormValue(facet.code);
                              if (formValue) {
                                isChecked = formValue.includes(code);
                              }
                              return (
                                <div
                                  className="facet-filter-modal__item facet-linkhead"
                                  key={`facet-filter-modal-item-${k_item}`}
                                >
                                  <input
                                    {...getFormDefaultProps({
                                      type: 'checkbox',
                                      name: facet.code,
                                      value: code
                                    })}
                                    id={`modal-${name}`}
                                    checked={isChecked}
                                  />
                                  <label
                                    className={`${
                                      facet.code == 'verticalcolorfamily'
                                        ? `facet-color facet-color-${name} facet-color-${facet.code}`
                                        : ''
                                    } ${isChecked ? 'facet-checked' : 'facet-unchecked'}`}
                                    htmlFor={`modal-${name}`}
                                  >
                                    <div className="popup-facet-name" aria-label={`${l3Category} with ${commify(count)} items`}>
                                      {`${l3Category} (${commify(count)})`}
                                    </div>
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="facet-filter-modal__footer">
                  <div className="facet-filter-modal__form-actions">
                    <Button
                      className="select-all"
                      modifier={['filter-footer-action', 'select-all']}
                      type="button"
                      onClick={e => {
                        addFormValue(facet.code, []);
                        e.stopPropagation();
                      }}
                      aria-label="Clear All">
                      Clear All
                    </Button>
                    <Button
                      type="submit"
                      className="apply-popup-button"
                      modifier={['filter-footer-action', 'apply']}
                      aria-label="Apply">
                      Apply
                    </Button>
                  </div>
                </div>
              </div>
            );
          }}
        </Form>
      </Modal>
    );
  }

  render() {
    return <div className="facets-modal-popup">{this.renderCategoryModal()}</div>;
  }
}

function mapStateToProps(state) {
  const { facets = {}, modals = {} } = state;
  const modal = modals['facet-filter-modal-category'] || {};
  const facetId = modal.state ? modal.state.facetId : null;
  const { currentFacets = {}, plpGender = "" } = facets;
  const { entities = {} } = currentFacets;
  const { query: facetsQuery } = currentFacets;
  return {
    entities,
    facetsQuery,
    facetId,
    enableImprovedFacets: getEnableFilterImprovement(state) || false,
    filterImprovementConfig: getFilterImprovementConfig(state) || {},
    plpGender,
  };
}
function mapDispatchToProps(dispatch, ownProps) {
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    },
    setCurentFacetsQuery: query => {
      dispatch(setCurentFacetsQuery(query));
    }
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FacetCheckboxModalContentDesktop)
);
